import React from "react";
import { BookOpen, ClipboardList, Users, Baby, Clock3 } from "lucide-react";
import { PageBanner, SectionTitle } from "../components/Shared";
import { PROGRAMS, TIMINGS, CLASSES } from "../data/siteData";
import "./InnerPages.css";

const AcademicsPage = () => {
  return (
    <>
      <PageBanner title="Academics" breadcrumb="Academics" />

      {/* Programs */}
      <section className="section">
        <div className="container">
          <SectionTitle
            title="Academic Programs"
            subtitle="CBSE curriculum from Pre-Nursery to Grade VIII"
          />
          <div className="grid-3">
            {PROGRAMS.map((p) => (
              <div
                key={p.title}
                className="program-card card"
                style={{ borderLeft: `4px solid ${p.color}` }}
              >
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timings */}
      <section className="section section--bg">
        <div className="container">
          <SectionTitle title="School Timings" />
          <div className="timing-table card">
            {TIMINGS.map(([label, time], i) => (
              <div
                key={label}
                className="timing-row"
                style={{
                  borderBottom:
                    i < TIMINGS.length - 1 ? "1px solid var(--border)" : "none",
                }}
              >
                <span className="timing-row__label">{label}</span>
                <span className="timing-row__time">{time}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Methodology & Curriculum */}
      <section className="section">
        <div className="container grid-2" style={{ gap: 28 }}>
          <div className="info-card card">
            <h3 className="info-card__title"><BookOpen size={20} /> Methodology</h3>
            <p>
              Our teaching methodology integrates traditional and modern
              approaches. We use activity-based learning, project work, group
              discussions, presentations, and digital tools to make learning
              interactive and enjoyable. Each child is given individual attention
              to ensure they grasp concepts thoroughly.
            </p>
          </div>
          <div className="info-card card">
            <h3 className="info-card__title"><ClipboardList size={20} /> Curriculum</h3>
            <p>
              IDPS Mahore follows the CBSE curriculum with English as the medium
              of instruction. The curriculum is enriched with co-curricular and
              extra-curricular activities including sports, art, music, dance,
              and computer education. Continuous and comprehensive evaluation
              (CCE) system is followed.
            </p>
          </div>
        </div>
      </section>

      {/* Classes */}
      <section className="section section--bg">
        <div className="container">
          <SectionTitle
            title="Our Popular Classes"
            subtitle="Diverse classes designed to spark curiosity and a love for learning."
          />
          <div className="grid-3">
            {CLASSES.map((c) => (
              <div key={c.title} className="class-card card">
                <img src={c.img} alt={c.title} className="class-card__img" />
                <div className="class-card__body">
                  <h3>{c.title}</h3>
                  <p>{c.desc}</p>
                  <div className="class-card__meta">
                    <span><Users size={14} /> 30–40</span>
                    <span><Baby size={14} /> Age 6–9</span>
                    <span><Clock3 size={14} /> 8–10 AM</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default AcademicsPage;
